import { render, staticRenderFns } from "./SelectTransferOption.vue?vue&type=template&id=07c132b0&scoped=true"
import script from "./SelectTransferOption.vue?vue&type=script&lang=js"
export * from "./SelectTransferOption.vue?vue&type=script&lang=js"
import style0 from "./SelectTransferOption.vue?vue&type=style&index=0&id=07c132b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c132b0",
  null
  
)

export default component.exports